const generateUniqueID = function () {
    return Date.now().toString(36) + '-' + Math.random().toString(36).substring(2)
}

export default {
    generateUniqueID,
    yaMetrika: {
        track(...args) {
            try {
                const ym = window.ym

                if (ym) {
                    const initEvent = (ym.a || []).find((i) => i[1] === 'init')
                    if (initEvent) ym(initEvent[0], ...args)
                }
            } catch (e) {
                console.error('ym error:', e)
            }
        },
    },
}



// WEBPACK FOOTER //
// ./src/helper.js